import api from '../../api'
import {normalize} from 'normalizr';
import download from "../../download";
import {sendNotification} from '../../application.actions'

export const PERIOD_RETRIEVED = 'PERIOD_RETRIEVED';
export const SAMPLE_DATA_CLEARED = 'SAMPLE_DATA_CLEARED';
export const SAMPLE_DATA_UPLOADED = 'SAMPLE_DATA_UPLOADED';
export const PATIENT_RESTORED_TO_SAMPLE = 'PATIENT_RESTORED_TO_SAMPLE';
export const PATIENT_REMOVED_FROM_SAMPLE = 'PATIENT_REMOVED_FROM_SAMPLE';
export const NOTIFY_NURSING_FACILITIES = 'NOTIFY_NURSING_FACILITIES';
export const NURSING_FACILITIES_NOTIFIED = 'NURSING_FACILITIES_NOTIFIED';
export const DUE_DATE_SET = 'DUE_DATE_SET';
export const SAMPLE_UI_STATE_RESET = 'SAMPLE_UI_STATE_RESET';
export const ACTIVE_TAB_SET = 'ACTIVE_TAB_SET';

export const FILTERS_SET = 'FILTERS_SET';
export const FILTERS_CLEARED = 'FILTERS_CLEARED';

export const clearSampleData = () => ({type: SAMPLE_DATA_CLEARED});
export const resetSampleUiState = () => ({type: SAMPLE_UI_STATE_RESET});
export const setActiveTab = id => ({type: ACTIVE_TAB_SET, payload: id});

export const removePatient = (patientId) => async (dispatch, getState) => {
  const periodId = getState().sample.selectedPeriod;
  return await api(dispatch).delete(`periods/${periodId}/records/${patientId}`, response => [
    {type: PATIENT_REMOVED_FROM_SAMPLE, payload: response},
    sendNotification('Patient removed from Sample')
  ]);
};

export const restorePatient = (patientId) => async (dispatch, getState) => {
  const periodId = getState().sample.selectedPeriod;
  return await api(dispatch).post(`periods/${periodId}/records/${patientId}`, response => [
    {type: PATIENT_RESTORED_TO_SAMPLE, payload: response},
    sendNotification('Patient restored to Sample')
  ]);
};

export const setFilters = filters => ({type: FILTERS_SET, payload: filters});
export const clearFilters = () => ({type: FILTERS_CLEARED});

export const fetchPeriod = periodId => async (dispatch, getState, {schema}) => {
  return await api(dispatch).get(`periods/${periodId}`, response => ({
    type: PERIOD_RETRIEVED,
    payload: {
      ...normalize(response, schema.reviewPeriod),
      removedPatientIds: (response.data || []).filter(x => x.removed).map(x => x.id),
      selectedPeriod: periodId
    }
  }));
};

export const notifyNursingFacilities = periodId => async dispatch => {
  dispatch({type: NOTIFY_NURSING_FACILITIES});
  return await api(dispatch).post(`periods/${periodId}/notification`, response => [
    {type: NURSING_FACILITIES_NOTIFIED, payload: response},
    sendNotification('Nursing facilities have been notified.')
  ]);
};

export const setDueDate = (periodId, dueDate) => async dispatch => {
  return await api(dispatch).post(`periods/${periodId}/duedate`, {periodId, dueDate}, response => [
    {type: DUE_DATE_SET, payload: response},
    sendNotification('Due date set')
  ]);
};

export const uploadSampleData = (periodId, file) => async (dispatch, getState, {schema}) => {
  const data = new FormData();
  data.append('file', file);
  return await api(dispatch).upload(`periods/${periodId}/sampledata`, data, response => [
      {type: SAMPLE_DATA_UPLOADED, payload: normalize(response.items, [schema.patient])},
      sendNotification(`${response.items.length} records imported successfully.`)
    ]
  );
};

export const deleteSampleData = () => async (dispatch, getState) => {
  const periodId = getState().sample.selectedPeriod;
  return await api(dispatch).delete(`periods/${periodId}/sampledata`, ({quarterlyStatus, quarterlyStatusValue}) => [
    {type: SAMPLE_DATA_CLEARED, payload: {quarterlyStatus, quarterlyStatusValue}},
    dispatch(sendNotification('Sample data cleared.'))
  ]);
};

export const downloadSampleTemplate = (e) => async (dispatch) => {
  e.preventDefault();
  const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const blob = await api(dispatch).download('epasrr/sample/template', contentType);
  download(blob, 'CR Sample Template.xlsx', contentType);
};



// WEBPACK FOOTER //
// ./src/modules/sample/sample.actions.js